export const PREDICTION_WIDGET = {
  ACTION_TYPES: {
    tabChange: 'tabChange',
    marketNavigationClick: 'marketNavigationClick',
    onTabClick: 'onTabClick',
    populateData: 'populateData'
  },

  DIRECTIONS: {
    prev: 'prev',
    next: 'next'
  },

  TABS: {
    main: 0,
    props: 1
  },

  TABS_LABEL: {
    main: 'main',
    props: 'props'
  },

  LOGO_SIZES: {
    ATHLETE: {
      desktop: 56,
      mobile: 40
    }
  }
}
